<div class="tw-flex tw-w-full tw-flex-col tw-items-start tw-relative tw-pb-2.5 tw-px-6">
    <div class="tw-flex tw-flex-col tw-w-full tw-gap-y-7 tw-bg-white tw-sticky tw-pb-5 tw-pt-[30px] tw-top-0 tw-z-20">
        <div class="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-x-4">
            <p *ngIf="isLoggedIn" class="tw-button-text-1 tw-text-color-1">Hi {{currentUser?.name||'User'}} </p>
            <p *ngIf="!isLoggedIn" class="tw-button-text-1 tw-text-color-1">Hey there! </p>
            <button type="button" class="btn p-0" aria-label="Close" (click)="closeMenu(true)">
                <common-icons iconName="x" class="tw-w-5 tw-h-5 tw-text-primary-500 tw-cursor-pointer"
                    aria-hidden="true"></common-icons>
            </button>
        </div>
        <pickright-button text="Login" type="fill" class="tw-w-full" *ngIf="!isLoggedIn"
            (btnClick)="goTo('login')"></pickright-button>
    </div>
    <div class="tw-overflow-hidden tw-overflow-y-auto md:tw-p-0 tw-w-full">
        <ng-container *ngIf="pendingProfile  && isLoggedIn">
            <ng-container *ngIf="pendingProfile?.name === 'pan_verification'">
                <ng-container *ngTemplateOutlet="panVerify"></ng-container>
            </ng-container>
            <ng-container *ngIf="pendingProfile?.name === 'kyc'">
                <ng-container *ngTemplateOutlet="kycPending"></ng-container>
            </ng-container>
            <ng-container *ngIf="pendingProfile?.name === 'risk_profiling'">
                <ng-container *ngTemplateOutlet="riskProfile"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngTemplateOutlet="discoverPickright"></ng-container>
        <ng-container *ngTemplateOutlet="menuDialog"></ng-container>
        <ng-container *ngIf="!pendingProfile && isLoggedIn && currentUser?.riskProfile">
            <ng-container *ngTemplateOutlet="referAndEarn"></ng-container>
        </ng-container>
        <div class="tw-flex tw-flex-col tw-w-full">
            <button type="button"
                class="tw-w-full tw-bg-[#4dc247] tw-flex tw-items-center tw-text-white tw-p-3 tw-rounded-lg tw-justify-center"
                (click)="chatOnWhatApp()">
                <social-share-icons iconName="whatsapp" class="tw-w-5 tw-h-5 tw-mr-2"></social-share-icons>
                Chat With Us
            </button>
            <p class="tw-label-2 tw-items-center tw-text-color-2 tw-m-auto tw-opacity-50" *ngIf="isMobile">Current
                Version {{version}}</p>
        </div>
    </div>
</div>
<ng-template #riskProfile>
    <div tabindex="0" role="button" aria-label="Complete Profile"
        class="tw-flex tw-gap-x-5 tw-w-full tw-py-5 md:tw-py-2.5 tw-px-2.5 tw-my-5 tw-cursor-pointer tw-justify-between tw-items-center"
        (click)="goTo('risk-profile')" (keydown.enter)="$any($event.currentTarget).click()"
        (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()"
        [linearBackground]="{degree:89.95, color1: '#83FFCF',  color2: 'rgba(0, 240, 255, 0.3)',color1Percent : 0.04, color2Percent: 99.95 }">
        <img src="assets/new-assets/menu/risk-profile-logo.svg" alt="Risk profile">
        <div class="tw-flex tw-flex-col">
            <h5 class="tw-text-color-1">Risk Profile</h5>
            <p class="tw-label-1 tw-text-color-2">Complete your profile now!</p>
        </div>
        <common-icons iconName="arrow-small"
            class="tw-w-5 tw-h-5 tw-text-primary-500 -tw-rotate-90 tw-ml-auto tw-cursor-pointer"></common-icons>
    </div>
</ng-template>
<ng-template #panVerify>
    <div tabindex="0" role="button" aria-label="Verify Pan"
        class="tw-flex tw-gap-x-5 tw-w-full tw-py-5 md:tw-py-2.5 tw-px-2.5 tw-my-5 tw-cursor-pointer tw-justify-between tw-items-center"
        (click)="goTo('risk-profile')" (keydown.enter)="$any($event.currentTarget).click()"
        (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()"
        [linearBackground]="{degree:89.95, color1: '#83FFCF',  color2: 'rgba(0, 240, 255, 0.3)',color1Percent : 0.04, color2Percent: 99.95 }">
        <img src="assets/new-assets/menu/risk-profile-logo.svg" alt="Verify pan">
        <div class="tw-flex tw-flex-col">
            <h5 class="tw-text-color-1">Verify PAN</h5>
            <p class="tw-label-1 tw-text-color-2">Complete your profile now!</p>
        </div>
        <common-icons iconName="arrow-small"
            class="tw-w-5 tw-h-5 tw-ml-auto tw-text-primary-500 -tw-rotate-90 tw-cursor-pointer"></common-icons>
    </div>
</ng-template>
<ng-template #kycPending>
    <div tabindex="0" role="button" aria-label="Complete KYC"
        class="tw-flex tw-gap-x-5 tw-w-full tw-py-5 md:tw-py-2.5 tw-px-2.5 tw-my-5 tw-cursor-pointer tw-justify-between tw-items-center"
        (click)="goTo('risk-profile')" (keydown.enter)="$any($event.currentTarget).click()"
        (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()"
        [linearBackground]="{degree:89.95, color1: '#83FFCF',  color2: 'rgba(0, 240, 255, 0.3)',color1Percent : 0.04, color2Percent: 99.95 }">
        <img src="assets/new-assets/menu/risk-profile-logo.svg" alt="KYC pending">
        <div class="tw-flex tw-flex-col">
            <h5 class="tw-text-color-1">KYC Pending</h5>
            <p class="tw-label-1 tw-text-color-2">Complete your profile now!</p>
        </div>
        <common-icons iconName="arrow-small"
            class="tw-w-5 tw-h-5 tw-text-primary-500 -tw-rotate-90 tw-ml-auto tw-cursor-pointer"></common-icons>
    </div>
</ng-template>
<ng-template #referAndEarn>
    <div tabindex="0" role="button" aria-label="Refer and Earn"
        class="bg-refer-earn tw-w-full tw-flex tw-items-center tw-p-1 tw-rounded-md it tw-my-2 tw-cursor-pointer tw-justify-between"
        (click)="goTo('refer-earn')" (keydown.enter)="$any($event.currentTarget).click()"
        (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
        <img src="assets/new-assets/menu/refer-earn-logo.svg" alt="Refer and earn">
        <div class="tw-flex tw-flex-col tw-ml-[6px]">
            <h5 class="tw-text-color-1">Refer & Earn</h5>
            <p class="tw-label-1 tw-text-color-2">Get exciting rewards for each referral</p>
        </div>
        <common-icons iconName="arrow-small"
            class="tw-w-5 tw-h-5 tw-text-primary-500 -tw-rotate-90 tw-ml-auto tw-cursor-pointer"></common-icons>
    </div>
</ng-template>
<ng-template #discoverPickright>
    <div class="tw-flex tw-flex-col tw-mb-4 md:tw-mb-3">
        <div class="tw-flex tw-items-center tw-justify-between tw-mb-3">
            <h6 class="tw-text-color-1">Explore Pickright</h6>
            <pickright-button text="View All" size="small" type="link" (btnClick)="goTo('products')"></pickright-button>
        </div>
        <div
            class="tw-flex tw-gap-x-4 tw-flex-wrap tw-items-center tw-justify-around md:tw-justify-start tw-gap-y-5 md:tw-gap-x-2.5">
            <div tabindex="0" role="button" aria-label="Go to Investpack" class="tw-flex tw-items-center tw-flex-col tw-label-1 tw-w-52 tw-h-32 md:tw-w-[130px] md:tw-h-28 tw-text-color-1 tw-cursor-pointer tw-text-center md:tw-min-h-20 
            investpackBG !tw-bg-cover !tw-bg-center tw-relative tw-rounded-lg" (click)="goTo('investment')"
                *ngIf="allVerticals?.investment" (keydown.enter)="$any($event.currentTarget).click()"
                (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
                <img class="md:tw-w-[90px] tw-w-[120px] tw-absolute tw-bottom-0 tw-right-0"
                    src="assets/new-assets/menu/investpackBgIcon.png" alt="InvestPack logo">
                <!-- InvestPack -->
                <div
                    class="tw-flex tw-w-full tw-flex-col tw-gap-4 md:tw-gap-2 tw-absolute !tw-top-4 !tw-left-4 md:!tw-top-2 md:!tw-left-2.5 tw-items-start tw-justify-start">
                    <h6 class="tw-text-white">Investpack</h6>
                    <div class="tw-flex tw-w-full tw-flex-row tw-gap-1">
                        <div
                            class="tw-flex tw-w-4 tw-h-4 tw-rounded-full tw-bg-white tw-p-1 tw-items-center tw-justify-center">
                            <common-icons iconName="arrow-left"
                                class="tw-text-color-1 tw-rotate-[135deg] tw-w-3 tw-h-3"></common-icons>
                        </div>
                        <p class="tw-button-text-3 tw-text-white">Explore</p>
                    </div>
                </div>
            </div>
            <div tabindex="0" role="button" aria-label="Go to Trading" class="tw-flex tw-items-center tw-flex-col tw-label-1 tw-w-52 tw-h-32 md:tw-w-[130px] md:tw-h-28 tw-text-color-1 tw-cursor-pointer tw-text-center md:tw-min-h-20
            tradingkBG !tw-bg-cover !tw-bg-center tw-relative tw-rounded-lg" matRipple matRippleColor="CEE4E4"
                (click)="goTo('trading')" *ngIf="allVerticals?.trading"
                (keydown.enter)="$any($event.currentTarget).click()"
                (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
                <img class="md:tw-w-[90px] tw-w-[120px] tw-absolute tw-bottom-0 tw-right-0"
                    src="assets/new-assets/menu/tradingBgIcon.png" alt="Trading logo">
                <!-- Trading Advisory -->
                <div
                    class="tw-flex tw-w-full tw-flex-col tw-gap-4 md:tw-gap-2 tw-absolute !tw-top-4 !tw-left-4 md:!tw-top-2 md:!tw-left-2.5 tw-items-start tw-justify-start">
                    <h6 class="tw-text-white">Trading Advisory</h6>
                    <div class="tw-flex tw-w-full tw-flex-row tw-gap-1">
                        <div
                            class="tw-flex tw-w-4 tw-h-4 tw-rounded-full tw-bg-white tw-p-1 tw-items-center tw-justify-center">
                            <common-icons iconName="arrow-left"
                                class="tw-text-color-1 tw-rotate-[135deg] tw-w-3 tw-h-3"></common-icons>
                        </div>
                        <p class="tw-button-text-3 tw-text-white">Explore</p>
                    </div>
                </div>
            </div>
            <div tabindex="0" role="button" aria-label="Go to Mutual fund"
                class="tw-flex tw-items-center tw-flex-col tw-label-1 tw-w-[30%] tw-text-color-1 tw-cursor-pointer tw-text-center md:tw-min-h-20"
                matRipple matRippleColor="CEE4E4" (click)="goTo('mutual-funds')" *ngIf="allVerticals?.mutual_fund"
                (keydown.enter)="$any($event.currentTarget).click()"
                (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
                <img class="md:tw-w-[65px] tw-w-[95px] tw-mb-2" src="assets/new-assets/menu/mutual-fund-logo.png"
                    alt="Mutual Fund logo">
                Mutual Fund
            </div>
            <div tabindex="0" role="button" aria-label="Go to Cryptocurrency"
                class="tw-flex tw-items-center tw-flex-col tw-label-1 tw-w-[30%] tw-text-color-1 tw-cursor-pointer tw-text-center md:tw-min-h-20"
                matRipple matRippleColor="CEE4E4" (click)="goTo('crypto')" *ngIf="allVerticals?.crypto_currency"
                (keydown.enter)="$any($event.currentTarget).click()"
                (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
                <img class="md:tw-w-[65px] tw-w-[95px] tw-mb-2" src="assets/new-assets/menu/crypto-currency-logo.png"
                    alt="Cryptocurrency logo">
                Cryptocurrency
            </div>
            <div tabindex="0" role="button" aria-label="Go to Digital Savings"
                class="tw-flex tw-items-center tw-flex-col tw-label-1 tw-w-[30%] tw-text-color-1 tw-cursor-pointer tw-text-center md:tw-min-h-20"
                matRipple matRippleColor="CEE4E4" (click)="goTo('digital-savings')"
                *ngIf="allVerticals?.digital_savings" (keydown.enter)="$any($event.currentTarget).click()"
                (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
                <img class="md:tw-w-[65px] tw-w-[95px] tw-mb-2" src="assets/new-assets/menu/micro-savings-logo.png"
                    alt="Digital Savings logo">
                Digital Savings
            </div>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLScWTFvBDwiYSrp27YJSjLEPMjcGx_RzMwIZ40Yek2TeijbvGQ/viewform"
                class="tw-flex tw-items-center tw-flex-col tw-label-1 tw-w-[30%] tw-text-color-1 tw-cursor-pointer tw-text-center md:tw-min-h-20"
                matRipple matRippleColor="CEE4E4" *ngIf="allVerticals?.customized_planning">
                <img class="md:tw-w-[65px] tw-w-[95px] tw-mb-2" src="assets/new-assets/menu/financial-planning-logo.png"
                    alt="Financial Planning logo">
                Financial Planning
            </a>
        </div>

    </div>
</ng-template>
<ng-template #menuDialog>
    <div class="tw-flex tw-w-full tw-flex-col tw-mb-2 selector">
        <div tabindex="0" role="button" aria-label="My Account"
            class="tw-flex tw-w-full tw-border-b tw-min-h-[70px] tw-max-h-[70px] md:tw-min-h-[60px] md:tw-max-h-[60px] tw-cursor-pointer tw-p-5 md:tw-py-4 md:tw-px-2.5 tw-rounded-lg"
            (click)="goTo('profile')" matRipple matRippleColor="CEE4E4" *ngIf="isLoggedIn"
            (keydown.enter)="$any($event.currentTarget).click()"
            (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
            <div class="tw-flex tw-w-full tw-items-center">
                <div class="tw-flex tw-items-center tw-gap-x-4 tw-para-1 tw-text-color-1">
                    <common-icons iconName="user-circle"
                        class="tw-w-5 tw-h-5 tw-text-primary-500 tw-cursor-pointer"></common-icons>
                    My Account
                </div>
            </div>
        </div>
        <div tabindex="0" role="button" aria-label="Risk Profile"
            class="tw-flex tw-w-full tw-border-b tw-min-h-[70px] tw-max-h-[70px] md:tw-min-h-[60px] md:tw-max-h-[60px] tw-cursor-pointer tw-p-5 md:tw-py-4 md:tw-px-2.5 tw-rounded-lg"
            (click)="goTo('risk-profile')" matRipple matRippleColor="CEE4E4" *ngIf="(!pendingProfile) || !isLoggedIn"
            (keydown.enter)="$any($event.currentTarget).click()"
            (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
            <div class="tw-flex tw-w-full tw-items-center tw-justify-between">
                <div class="tw-flex tw-items-center tw-gap-x-4 tw-para-1 tw-text-color-1">
                    <common-icons iconName="gauge"
                        class="tw-w-5 tw-h-5 tw-text-primary-500 tw-cursor-pointer"></common-icons>
                    Risk Profile
                </div>
                <div class="tw-flex">
                    <p class="tw-text-primary-500 tw-para-2" *ngIf="!isLoggedIn ">Start Now</p>
                    <div class="tw-bg-[#FFE5E5] tw-py-2.5 tw-px-6 tw-rounded-3xl tw-min-w-[100px] md:tw-min-w-[80px]"
                        *ngIf="currentUser?.riskProfile && currentUser?.riskValue === 'aggressive'">
                        <p class="tw-label-2 tw-text-[#5C0A0A]">Aggressive</p>
                    </div>
                    <div class="tw-bg-[#FFF6E5] tw-py-2.5 tw-px-6 tw-rounded-3xl tw-min-w-[100px] md:tw-min-w-[80px]"
                        *ngIf="currentUser?.riskProfile && currentUser?.riskValue === 'moderate'">
                        <p class="tw-label-2 tw-text-[#5C400A]">Moderate</p>
                    </div>
                    <!-- <div class="bg-color-F6FFE5 pt-10 pb-10 pr-25 pl-25 border-radius-25 min-width-10 min-width-md-8"
                        *ngIf="currentUser?.riskProfile && currentUser?.riskValue === 'balanced'">
                        <p class="fs-12 fs-md-10 color-405C0A fw-4 fw-md-3">Balanced</p>
                    </div> -->
                    <div class="tw-bg-[#E5FFEE] tw-py-2.5 tw-px-6 tw-rounded-3xl tw-min-w-[100px] md:tw-min-w-[80px]"
                        *ngIf="currentUser?.riskProfile && currentUser?.riskValue === 'conservative'">
                        <p class="tw-label-2 tw-text-[#0A5C0A]">Conservative</p>
                    </div>
                </div>
            </div>
        </div>
        <div tabindex="0" role="button" aria-label="My Billings"
            class="tw-flex tw-w-full tw-border-b tw-min-h-[70px] tw-max-h-[70px] md:tw-min-h-[60px] md:tw-max-h-[60px] tw-cursor-pointer tw-p-5 md:tw-py-4 md:tw-px-2.5 tw-rounded-lg"
            (click)="goTo('transactions')" matRipple matRippleColor="CEE4E4"
            (keydown.enter)="$any($event.currentTarget).click()"
            (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
            <div class="tw-flex tw-w-full tw-items-center">
                <div class="tw-flex tw-items-center tw-gap-x-4 tw-para-1 tw-text-color-1">
                    <common-icons iconName="wallet"
                        class="tw-w-5 tw-h-5 tw-text-primary-500 tw-cursor-pointer"></common-icons>
                    My Billings
                </div>
            </div>
        </div>
        <div tabindex="0" role="button" aria-label="My Rewards"
            class="tw-flex tw-w-full tw-border-b tw-min-h-[70px] tw-max-h-[70px] md:tw-min-h-[60px] md:tw-max-h-[60px] tw-cursor-pointer tw-p-5 md:tw-py-4 md:tw-px-2.5 tw-rounded-lg"
            (click)="goTo('rewards')" matRipple matRippleColor="CEE4E4"
            (keydown.enter)="$any($event.currentTarget).click()"
            (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
            <div class="tw-flex tw-w-full tw-items-center">
                <div class="tw-flex tw-items-center tw-gap-x-4 tw-para-1 tw-text-color-1">
                    <common-icons iconName="ticket"
                        class="tw-w-5 tw-h-5 tw-text-primary-500 tw-cursor-pointer"></common-icons>
                    My Rewards
                </div>
                <!-- <div class="bg-color-FF6B00 width-7-px height-7-px border-radius-circle ml-8 mb-8"></div> -->
            </div>
        </div>
        <div tabindex="0" role="button" aria-label="Refer and Earn"
            class="tw-flex tw-w-full tw-border-b tw-min-h-[70px] tw-max-h-[70px] md:tw-min-h-[60px] md:tw-max-h-[60px] tw-cursor-pointer tw-p-5 md:tw-py-4 md:tw-px-2.5 tw-rounded-lg"
            (click)="goTo('refer-earn')" matRipple matRippleColor="CEE4E4" *ngIf="!currentUser?.riskProfile"
            (keydown.enter)="$any($event.currentTarget).click()"
            (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
            <div class="tw-flex tw-w-full tw-items-center">
                <div class="tw-flex tw-items-center tw-gap-x-4 tw-para-1 tw-text-color-1">
                    <common-icons iconName="paper-plane-tilt"
                        class="tw-w-5 tw-h-5 tw-text-primary-500 tw-cursor-pointer"></common-icons>
                    Refer & Earn
                </div>
            </div>
        </div>
        <div tabindex="0" role="button" aria-label="Notification"
            class="tw-flex tw-w-full tw-border-b tw-min-h-[70px] tw-max-h-[70px] md:tw-min-h-[60px] md:tw-max-h-[60px] tw-cursor-pointer tw-para-1 tw-rounded-lg"
            matRipple matRippleColor="CEE4E4" *ngIf="isLoggedIn" (click)="openNotificationDialog()"
            (keydown.enter)="$any($event.currentTarget).click()"
            (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
            <app-user-notification-btn class="tw-w-full !tw-para-1" [iconColor]="'#2818E9'" [currentUser]="currentUser"
                [isApp]="isMobile">
            </app-user-notification-btn>
        </div>
        <div tabindex="0" role="button" aria-label="Help and Support"
            class="tw-flex tw-w-full tw-border-b tw-min-h-[70px] tw-max-h-[70px] md:tw-min-h-[60px] md:tw-max-h-[60px] tw-cursor-pointer tw-p-5 md:tw-py-4 md:tw-px-2.5 tw-rounded-lg"
            matRipple matRippleColor="CEE4E4" (click)="goTo('faq')" (keydown.enter)="$any($event.currentTarget).click()"
            (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
            <div class="tw-flex tw-w-full tw-items-center">
                <div class="tw-flex tw-items-center tw-gap-x-4 tw-para-1 tw-text-color-1">
                    <common-icons iconName="question"
                        class="tw-w-5 tw-h-5 tw-text-primary-500 tw-cursor-pointer"></common-icons>
                    Help & Support
                </div>
            </div>
        </div>
        <div tabindex="0" role="button" aria-label="Logout"
            class="tw-flex tw-w-full tw-border-b tw-min-h-[70px] tw-max-h-[70px] md:tw-min-h-[60px] md:tw-max-h-[60px] tw-cursor-pointer tw-p-5 md:tw-py-4 md:tw-px-2.5 tw-rounded-lg"
            (click)="logout()" *ngIf="isLoggedIn" matRipple matRippleColor="CEE4E4"
            (keydown.enter)="$any($event.currentTarget).click()"
            (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
            <div class="tw-flex tw-w-full tw-items-center">
                <div class="tw-flex tw-items-center tw-gap-x-4 tw-para-1 tw-text-color-1">
                    <common-icons iconName="sign-out"
                        class="tw-w-5 tw-h-5 tw-text-primary-500 tw-cursor-pointer"></common-icons>
                    Log Out
                </div>
            </div>
        </div>
    </div>
</ng-template>